// Frontend/src/unicodex_ui/services/portalMeteredApi.js
import api from "./apiClient";

function cleanParams(params = {}) {
  const out = {};
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    if (typeof v === "string" && v.trim() === "") return;
    out[k] = v;
  });
  return out;
}

const portalMeteredApi = {
  async listMeters(params = {}) {
    const res = await api.get("/api/metered/meters", { params: cleanParams(params) });
    return res.data; // { ok, total, limit, offset, rows }
  },

  async openSession(payload) {
    const res = await api.post("/api/metered/sessions/open", payload);
    return res.data; // { ok, session }
  },

  async recordSession(sessionId, payload) {
    const res = await api.post(`/api/metered/sessions/${sessionId}/record`, payload);
    return res.data; // { ok, session }
  },

  async closeSession(sessionId, payload) {
    const res = await api.post(`/api/metered/sessions/${sessionId}/close`, payload);
    return res.data; // { ok, session }
  },

  async listSessions(params = {}) {
    const res = await api.get("/api/metered/sessions", { params: cleanParams(params) });
    return res.data; // { ok, total, limit, offset, rows }
  },

  async getSession(sessionId) {
    const res = await api.get(`/api/metered/sessions/${sessionId}`);
    return res.data; // { ok, session }
  },
};

export default portalMeteredApi;
